module.exports = __webpack_public_path__ + "img/background05.3e514fbb.jpg";